import React from "react";
import Avatar from "../Avatar";

export default function CoachTopbar({ user, onOpenSearch, onToggleMobileMenu }) {
	return (
		<header className="coach-topbar">
			{/* Bouton hamburger visible uniquement sur mobile (CSS max-width:700px).
			    Toggle la sidebar en drawer. */}
			<button
				className="coach-topbar-menu-btn"
				onClick={onToggleMobileMenu}
				aria-label="Ouvrir le menu"
				type="button"
			>
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
					<line x1="3" y1="6" x2="21" y2="6" />
					<line x1="3" y1="12" x2="21" y2="12" />
					<line x1="3" y1="18" x2="21" y2="18" />
				</svg>
			</button>

			<div className="coach-topbar-left">
				<span className="coach-topbar-logo">Gymnote</span>
				<span className="coach-topbar-subtitle">Coach</span>
			</div>

			<button className="coach-topbar-search" onClick={onOpenSearch}>
				<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<circle cx="11" cy="11" r="8" />
					<line x1="21" y1="21" x2="16.65" y2="16.65" />
				</svg>
				<span className="coach-topbar-search-label">Rechercher un élève, un exercice…</span>
				<kbd className="coach-topbar-kbd">⌘ K</kbd>
			</button>

			<div className="coach-topbar-right">
				<div className="coach-topbar-user">
					<Avatar prenom={user?.prenom} nom={user?.nom} photo={user?.photoProfil} size={32} />
					<span className="coach-topbar-username">
						{user?.prenom} {user?.nom?.charAt(0)}.
					</span>
				</div>
			</div>
		</header>
	);
}
